package com.github.jangalinski.tabweb.table

import com.github.jangalinski.tabweb._foundation.css.cssClass

/**
 * CSS class constants for Tabweb tables.
 */
data object TableCss {
  val TABLE = cssClass("table")
  val TABLE_CARD = cssClass("card-table")
  val TABLE_VCENTER = cssClass("table-vcenter")
  val TABLE_CENTER = cssClass("table-center")
  val TABLE_STRIPED = cssClass("table-striped")
  val TABLE_STRIPED_COLUMNS = cssClass("table-striped-columns")
  val TABLE_HOVER = cssClass("table-hover")
  val TABLE_BORDERED = cssClass("table-bordered")
  val TABLE_BORDERLESS = cssClass("table-borderless")
  val TABLE_SM = cssClass("table-sm")
  val TABLE_NOWRAP = cssClass("table-nowrap")
  val TABLE_TRANSPARENT = cssClass("table-transparent")
  val TABLE_SELECTABLE = cssClass("table-selectable")
  val TABLE_ACTIVE = cssClass("table-active")
  val TABLE_STICKY_HEADER = cssClass("table-sticky-header")
  val STICKY_TOP = cssClass("sticky-top")
  val TEXT_NOWRAP = cssClass("text-nowrap")
  val TEXT_SECONDARY = cssClass("text-secondary")
  val TD_TRUNCATE = cssClass("td-truncate")
  val TABLE_PLACEHOLDER_ROW = cssClass("table-placeholder-row")
}
